// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"7faa9bb3","85":"786f3f15","270":"742edc5f","649":"54eeee14","811":"f0819570"}[chunkId] + ".chunk.css";
};